export const routes = {
  main: "/",
  login: "/login",
  signUp: "/sign-up",
  ticTacToe: "/tic-tac-toe",
}
